import Button from "./button"
import Heading from "./heading"
import Link from "./link"
import MatsDisplayWidget from "./mats-display-widget"
import Progress from "./progress"
import Text from "./text"
import TokenAmountInput from "./token-amount-input"

export default {
  Button,
  Heading,
  Link,
  MatsDisplayWidget,
  Progress,
  Text,
  TokenAmountInput,
}
